import React from "react";
import { Link } from "react-router-dom";

// test page for testing endpoints
const SamplePage = () => {

    

    return (
        <div>
            <h1>Sample Page</h1>
            <Link to="/course-catalog">Course-Catalog</Link>
        </div>
    );
}

export default SamplePage;